export enum BlockAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}
